import { UserIdentity } from '../../types/types';

const eqUserIdentities = (firstIdentity: UserIdentity, secondIdentity: UserIdentity): boolean => (
    firstIdentity.id === secondIdentity.id
    || firstIdentity.email?.toLowerCase() === secondIdentity.email?.toLowerCase()
);

export default eqUserIdentities;
